import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Container, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

import url from "@/router/urls";

import HeaderTopLang from "@Templates/header/AppHeader/HeaderTopLang";

import styles from "@Templates/header/AppHeader/HeaderTopBar.module.sass";

import TopBarMenuRow from "@Templates/header/AppHeader/TopBarMenuRow";
import TopBarMenuRowMobile from "@Templates/header/AppHeader/TopBarMenuRowMobile";

const HeaderTopBar = ({ setLang, collapsed }) => {
	const { t } = useTranslation();

	const [isMobile, setIsMobile] = useState(window.innerWidth < 991.98);

	const updateMedia = () => {
		setIsMobile(window.innerWidth < 991.98);
	};

	useEffect(() => {
		window.addEventListener("resize", updateMedia);
		return () => window.removeEventListener("resize", updateMedia);
	});

	return (
		<div className={ `${collapsed ? styles["top-bar__collapsed"] : styles["top-bar"]
            }` }
		>
			<Container className={ styles["top-bar__container"] }>
				<Row className={ styles["top-bar__row"] }>
					<div className={ styles["top-bar__row__how-to-start"] }>
						<Dropdown align='end'>
							<Dropdown.Toggle
								id='dropdown-custom-11'
								className={ styles["top-bar__row__how-to-start__button"] }
							>{t('transcriptionHelpPage.howToTranscribe.title')}
							</Dropdown.Toggle>

							<Dropdown.Menu className={ styles["top-bar__row__how-to-start-dropdown__menu"] }>
								<Link
									className={ `dropdown-item ${styles["top-bar__row__how-to-start-dropdown__item"]}` }
									to={{ pathname: url.howToTranscribe }}
								>{t('transcriptionHelpPage.howToTranscribe.title')}
								</Link>
								<Link
									className={ `dropdown-item ${styles["top-bar__row__how-to-start-dropdown__item"]}` }
									to={{ pathname: url.contact }}
								>{t('headers.informationsMenu.contact')}
								</Link>
							</Dropdown.Menu>
						</Dropdown>
					</div>
					<div className={ styles["top-bar__item--access"] } />
					<div className={ styles["top-bar__item"] + " " + styles["top-bar__item--lang"] }>
						<HeaderTopLang setLang={ setLang } />
					</div>
				</Row>

				{!isMobile ? <TopBarMenuRow/> : <TopBarMenuRowMobile/>}
			</Container>
		</div>
	);
};

HeaderTopBar.propTypes = {
	setLang: PropTypes.func,
	collapsed: PropTypes.bool,
};

export default HeaderTopBar;
